import { PayloadAction, Tuple, configureStore } from '@reduxjs/toolkit'
import { createEpicMiddleware } from 'redux-observable';
import user from './modules/user/userSlice';
import blogger from './modules/user/blogger/bloggerSlice';
import ui from './modules/app/uiStateSlice';
import app from './modules/app/appStateSlice';

import { rootEpic } from './rootEpic';

const storeType = configureStore({
  reducer: {
    user,
    blogger,
    ui,
    app
  }
});

export type RootState = ReturnType<typeof storeType.getState>;
export type AppDispatch = typeof storeType.dispatch;
export type StoreType = typeof storeType;

// NOTE: a fresh store per call (no module-level singleton). The react-ssr
// lambda renders many URLs in one process — a cached singleton store would keep
// the FIRST render's preloadedState, so every other page rendered with no
// cached post (article body collapsed to "loading..."). Each store also needs
// its own epic middleware instance.
export const createStore = (preloadedState?: RootState) => {
  const epicMiddleware = createEpicMiddleware<PayloadAction<any>, PayloadAction<any>, any>();

  const configuredStore = configureStore({
    reducer: {
      user,
      blogger,
      ui,
      app
    },
    preloadedState,
    middleware: () => new Tuple(epicMiddleware)
  });


  epicMiddleware.run(rootEpic);

  return configuredStore;
}
